class GTM {
    push(event) {
        if (event) {
            window.dataLayer.push(event);
        }
    }
}

export default new GTM();



// WEBPACK FOOTER //
// ./app/general/js/gtm.js